module.exports = __webpack_public_path__ + "img/CM-MC-26-CJDR-Lifestyle.4b523531.jpg";